const getFileExtension = fileName => {
  return fileName
    .split(".")
    .pop()
    .toLowerCase();
};

export default getFileExtension;
